const forgotPassword = {
  title: "Forgot Password",
  subtitle: "Enter your email address and we'll send you instructions to reset your password.",
  emailLabel: "Email Address",
  emailPlaceholder: "your.email@example.com",
  sending: "Sending...",
  submit: "Send Reset Instructions",
  backToLogin: "Back to Login",
  emailSent: {
    title: "Email Sent",
    messagePrefix: "If an account exists with the email",
    messageSuffix: ", you will receive password reset instructions shortly.",
    checkEmail: "Please check your email and follow the instructions to reset your password.",
  },
  errors: {
    sendFailed: "Failed to send reset email",
  },
};

export default forgotPassword;
